export function getLocalDateString(date: Date): string {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export const convertInCurrentLang = (lang: string, val: string): string => {
  if (lang === "bn") {
    // Loop through each character and convert to Bengali digits
    return val.replace(/\d/g, (digit) => {
      return String.fromCharCode(2534 + parseInt(digit, 10));
    });
  } else if (lang === "en") {
    // For English, look for bengali digits and convert them back to English digits
    return val.replace(/[\u09E6-\u09EF]/g, (digit) => {
      return String.fromCharCode(digit.charCodeAt(0) - 2534);
    });
  }
  return val;
};

export const convertNumberInCurrentLang = (
  lang: string,
  val: number
): string => {
  if (lang === "bn") {
    return new Intl.NumberFormat("bn-BD").format(val);
  } else if (lang === "en") {
    return new Intl.NumberFormat("en-US").format(val);
  }
  return val.toString();
};

export const convertWeight = (
  weight: number,
  from_unit: "gm" | "oz",
  to_unit: "gm" | "oz"
) => {
  if (from_unit === to_unit) {
    return weight;
  }
  return to_unit === "oz" ? weight / 28.3495 : weight * 28.3495;
};
